import { useEffect } from 'react';
import { Location, Table } from '../../my-lemonade-library/model/Location';
import { PaymentType } from '../../my-lemonade-library/model/Order';
import { EnvNames } from '../../my-lemonade-library/src/common/configs/EnvNames';
import { LYF_SUBDOMAIN_MAP } from '../../my-lemonade-library/src/payments/configs/LyfPaymentUrls';

export const useLyfSubdomainRedirect = (
    selectedLocation: Location | null | undefined,
    selectedTable: Table | null | undefined
) => {

    const tablePaymentRestrictions = selectedTable?.restrictions?.supported_payment_types_refs;
    // If no restrictions, simply use supported_payment_types
    const paymentTypes = tablePaymentRestrictions && tablePaymentRestrictions.length > 0
        ? selectedLocation?.supported_payment_types?.filter((spt) =>
            tablePaymentRestrictions.includes(spt.ref)
        )
        : selectedLocation?.supported_payment_types;

    const hasLyfCB = paymentTypes?.some(spt => spt.type === PaymentType.LYF_CB) ?? false;
    const hasOnlyLyfAndTable = paymentTypes?.every(spt =>
        [PaymentType.LYF_CB, PaymentType.TABLE].includes(spt.type)
    ) ?? false;

    const isLyfRedirectEnabled = hasLyfCB && hasOnlyLyfAndTable && (paymentTypes?.length ?? 0) <= 2;

    useEffect(() => {
        if (!selectedLocation || !selectedTable || process.env.REACT_APP_ENV === EnvNames.DEV) {
            return;
        }

        if (isLyfRedirectEnabled) {
            const currentEnv = process.env.REACT_APP_ENV as EnvNames;
            const lyfSubdomain = LYF_SUBDOMAIN_MAP[currentEnv];

            if (lyfSubdomain && window.location.origin !== lyfSubdomain) {
                window.location.href = `${lyfSubdomain}/${selectedTable.tablelink_id}`;
            }
        }
    }, [selectedLocation, selectedTable]);
};